import React from "react";
import { Users } from "lucide-react";

const CoursesSection = () => {
  const courses = [
    {
      title: "AI & Robotics",
      description: "Build robots, train AI models and create smart technology projects while learning engineering and problem-solving skills.",
      ageGroup: "Ages 10–16",
      img: "/img/ai-lab/course_robotics.png",
      imgAlt: "Kids learning artificial intelligence and robotics classes at Practido Learning Center Panipat",
      btnClass: "purple",
      delay: "delay-100"
    },
    {
      title: "Coding & Programming",
      description: "Learn Scratch, Python and app development through interactive coding challenges and real projects.",
      ageGroup: "Ages 6–14",
      img: "/img/ai-lab/course_coding.png",
      imgAlt: "Children attending live coding classes for kids at Practido Learning Center",
      btnClass: "blue",
      delay: "delay-200"
    },
    {
      title: "Design & Creativity",
      description: "Develop creative thinking through graphic design, digital art, UI/UX and design thinking activities.",
      ageGroup: "Ages 8–14",
      img: "/img/ai-lab/course_design.png",
      imgAlt: "Students developing UI/UX and design thinking for kids through digital art projects",
      btnClass: "pink",
      delay: "delay-300"
    },
    {
      title: "Video Editing & Content Creation",
      description: "Learn storytelling, video production and digital content creation using modern tools.",
      ageGroup: "Ages 10–16",
      img: "/img/ai-lab/course_art.png",
      imgAlt: "Kids learning digital storytelling and video editing classes for kids at Practido",
      btnClass: "orange",
      delay: "delay-100"
    },
    {
      title: "STEM & Innovation",
      description: "Explore science, technology, engineering and mathematics through experiments and hands-on challenges.",
      ageGroup: "Ages 8–14",
      img: "/img/ai-lab/course_drones.png",
      imgAlt: "Students exploring STEM learning center science and engineering projects with drone tech",
      btnClass: "green",
      delay: "delay-200"
    },
    {
      title: "AI-Powered Entrepreneurship",
      description: "Learn how technology can solve real-world problems and transform ideas into innovative solutions.",
      ageGroup: "Ages 12–18",
      img: "/img/ai-lab/course_3dprint.png",
      imgAlt: "School students learning artificial intelligence for students and starting tech projects",
      btnClass: "purple",
      delay: "delay-300"
    },
    {
      title: "Smart Money Skills",
      description: "Financial literacy for the next generation — savings, entrepreneurship and money mindset, taught the fun way.",
      ageGroup: "Ages 8–14",
      img: "/img/ai-lab/course_money.png",
      imgAlt: "Kids practicing future skills classes for kids including financial literacy and savings mindset",
      btnClass: "cyan",
      delay: "delay-400"
    }
  ];

  return (
    <section className="section courses section-shaded" id="courses">
      <div className="container">
        <div className="section-header reveal-triggered fade-up active">
          <h2>Future Skills Courses for <span className="text-gradient">Students</span></h2>
          <p>Comprehensive programs designed to build future-ready skills for students aged 6 to 18.</p>
        </div>

        <div className="courses-grid">
          {courses.map((course, index) => (
            <div key={index} className={`premium-card course-card reveal-triggered fade-up ${course.delay} active`}>
              <div className="course-media">
                <img src={course.img} alt={course.imgAlt} loading="lazy" />
              </div>
              <div className="course-info">
                <div className="course-badges">
                  <span className="badge badge-age">
                    <Users className="mr-1" size={14} />
                    {course.ageGroup}
                  </span>
                </div>
                <h3>{course.title}</h3>
                <p>{course.description}</p>
                <a
                  href="https://wa.me/919560734660"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`course-btn ${course.btnClass}`}
                  style={{ display: "inline-block", textDecoration: "none" }}
                >
                  Learn More
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CoursesSection;
